import { render } from "./InputButtonToggle.vue?vue&type=template&id=203c537a"
import script from "./InputButtonToggle.vue?vue&type=script&lang=js"
export * from "./InputButtonToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__